(function () {
  'use strict'

  angular.module('MktzapApp.Controllers')
    .controller('CompanyEditController', comp)

  comp.$inject = ['$window', '$scope', '$rootScope', '$http', '$stateParams', '$location', 'CompanyService', 'FoundationApi', 'UserService', 'UserAuditService', '$state', 'NumberService', 'EmailService', 'ChatService', 'SectorService', 'FacebookService', 'Upload', '$timeout', 'NotificationFactory', 'UserSignatureService', 'DashboardService', 'StatusService', 'NotificationService', 'SesameAuthService', 'ValidateService', 'ngTableParams', 'ProfileService', 'PermissionControlRoutes', 'LangService']

  function comp ($window, $scope, $rootScope, $http, $stateParams, $location, CompanyService, FoundationApi, UserService, UserAuditService, $state, NumberService, EmailService, ChatService, SectorService, FacebookService, Upload, $timeout, NotificationFactory, UserSignatureService, DashboardService, StatusService, NotificationService, SesameAuthService, ValidateService, ngTableParams, ProfileService, PermissionControlRoutes, LangService) {
    var vm = this

    vm.baseUrl = baseUrl
    vm.company = {}
    vm.channels = []
    vm.company_channels = []

    vm.company.webchats = []
    vm.company.emails = []
    vm.sesameLinks = [];

    vm.create_number = 'start'

    vm.creating_user = {}
    vm.editting_user = {}
    vm.selectedSectors = []
    vm.selectedSectorsTransferUser = []
    vm.deletingSesameLink = {};

    vm.ip = []
    vm.ip_add = []

    vm.selected_channel = undefined
    vm.selected_sector = undefined
    vm.selected_country = undefined
    vm.selected_locale = undefined
    vm.selected_timezone = undefined
    vm.selected_currency = 'R$'
    vm.timezones = undefined
    vm.locale = undefined
    vm.metadata = {}
    vm.autocomplete = {}
    vm.partnerautocomplete = {}
    vm.creating_user.companies = {}
    vm.creating_user.partner_companies = {}
    vm.classificationStatuses = []

    vm.first_date_field = ''
    vm.second_date_field = ''
    vm.third_date_field = ''

    vm.modalUserError = false
    vm.modalPartnerCompaniesError = false

    vm.profile = {}
    vm.permissionControl = {}
    vm.profileSearchForm = {}
    vm.disableButtonResetPermissions = true
    vm.profilesHierarchy = [];
    vm.editProfilesHierarchyList = [];
    vm.editProfileHierarchy = [];
    vm.modalMessage = '';
    vm.parentProfileId = 'null';
    vm.profileFilter = {};

    vm.dateClass = new Array(
      { 'value': 'd', 'text': 'Dia' },
      { 'value': 'm', 'text': 'Mês' },
      { 'value': 'Y', 'text': 'Ano' }
    )

    vm.currencies = new Array('R$', 'US$', '€')
    vm.allDateSeparator = [' ', '-', '/']
    vm.dateSeparator = '/'
    vm.sesameLink = '';

    vm.partnerCompanies = {};
    vm.partnerCompany = {};
    vm.partnerCompanyEdit = {};

    vm.userId = 0;

    LangService
      .getPageLabels({ 'page': 'permission.control.modules' })
      .$promise
      .then(function (data) {
        vm.labelsPage = data.lang;
      });

    LangService
      .getPageLabels({ 'page': 'permission.control.subModules' })
      .$promise
      .then(function (data) {
        vm.labelsSubModules = data.lang;
      });

    LangService
      .getPageLabels({ 'page': 'permission.control.actions' })
      .$promise
      .then(function (data) {
        vm.labelsActions = data.lang;
      });

    LangService
      .getPageLabels({ 'page': 'main.profile' })
      .$promise
      .then(function (data) {
        vm.labelsProfile = data.lang;
      })

    getPartnerCompanies()

    vm.isLord = $rootScope.checkMenuAccess('lord')

    var notifSet = new NotificationFactory({
      position: 'bottom-right'
    })

    if (vm.isLord) {
      CompanyService
        .getcompanies({ id: null })
        .$promise
        .then(function (data) {
          vm.autocomplete = data
        })
        .catch(function (error) {
          console.log(error)
        })

      StatusService
        .classification_statuses()
        .$promise
        .then(function (data) {
          vm.classificationStatuses = data
        })
        .catch(function (error) {
          console.log(error)
        })
    }

    vm.autocompleteFilterCompany = function ($query) {
      return vm.autocomplete.filter(function ($company) {
        return $company.name.toLowerCase().indexOf($query.toLowerCase()) != -1
      })
    }

    vm.autocompleteFilterUserPartnerCompany = function ($query) {
      return vm.partnerCompanies.filter(function ($user) {
        return $user.name.toLowerCase().indexOf($query.toLowerCase()) != -1
      })
    }

    CompanyService
      .loadMetadata()
      .$promise
      .then(function (data) {
        vm.metadata = data
      })
      .catch(function (error) {
        errorHandler(error, $rootScope.labels.errorLoadMetadatas)
      })

    CompanyService.find({
      id: $stateParams.id
    }, function (data) {
      vm.company = data
      vm.company.data = JSON.parse(vm.company.data)

      if (vm.company.webchats != undefined) {
      }
      if (vm.company.data && vm.company.data.use_filter_ip === undefined) {
        vm.company.data.use_filter_ip = false
        if (vm.company.data.ips !== undefined && vm.company.data.ips.length > 0) {
          vm.company.data.use_filter_ip = true
        }
      }
      if (vm.company.addresses == undefined || vm.company.addresses == null) {
        vm.company.addresses = [{
          tipo: '',
          logradouro: '',
          bairro: '',
          numero: '',
          cep: '',
          cidade: '',
          observacao: ''
        }]
      }
      if (vm.company.responsibles == undefined || vm.company.responsibles == null) {
        vm.company.responsibles = [{
          nome: '',
          email: '',
          celular: '',
          titulo: '',
          telefone: ''

        }]
      }
      if (vm.company.metadata !== undefined && vm.company.metadata !== null) {
        for (var i in vm.company.metadata) {
          if (typeof vm.company.metadata[i]['value'] === 'string') {
            vm.metadata[vm.company.metadata[i]['key']] = JSON.parse(vm.company.metadata[i]['value'])
          } else {
            vm.metadata[vm.company.metadata[i]['key']] = vm.company.metadata[i]['value']
          }
          if (vm.company.metadata[i]['key'] == 'localization') {
            vm.dateSeparator = vm.metadata[vm.company.metadata[i]['key']].separator
            let dateSeparator = vm.metadata[vm.company.metadata[i]['key']].date_format.split(vm.dateSeparator)
            vm.first_date_field = { 'value': dateSeparator[0] }
            vm.second_date_field = { 'value': dateSeparator[1] }
            vm.third_date_field = { 'value': dateSeparator[2] }
            vm.selected_country = vm.company['country']
            vm.timezones = vm.company['timezones']
            vm.locale = vm.company['locale']
            vm.selected_timezone = vm.metadata[vm.company.metadata[i]['key']].timezone
            vm.selected_currency = vm.metadata[vm.company.metadata[i]['key']].currency
            vm.selected_locale = vm.metadata[vm.company.metadata[i]['key']].locale
          }
        }
      }
    })

    CompanyService
      .allSectorsByKey({
        key: 'ai_classification'
      })
      .$promise
      .then(function (data) {
        vm.sectors = data
      })
      .catch(function (data) {
        NotificationService.errorHandler(data, $rootScope.labels.errorProcRequi)
      })

    vm.save = function () {
      vm.updateService(CompanyService, vm.company)
      $state.reload()
    }

    vm.updateService = function (service, content) {
      service.update({
        id: content.id
      },
      content,
      function () {
        successHandler(null, $rootScope.labels.sucUpdDatas)
      }, function (error) {
        errorHandler(error, $rootScope.labels.errorProcRequi)
      })
    }
    vm.createService = function (service, content, push_to, params) {
      service.create(params, content, function (data) {
        push_to.push(data)
        successHandler(data, $rootScope.labels.sucCreateDatas)
      }, function (error) {
        errorHandler(error, $rootScope.labels.errorProcRequi)
      })
    }
    vm.deleteService = function (service, content, splice_to, index) {
      service.delete({
        id: content.id
      }, function (data) {
        splice_to.splice(index, 1)
      })
      successHandler(null, $rootScope.labels.sucRemDatas)
    }

    // USUÁRIOS
    // adicionar usuários
    vm.loadProfilesByCompany = (selectedCompanyIndex) => {
      let companySelected = vm.companiesWithProfiles.find(company => company.id == vm.user.companiesAccess[selectedCompanyIndex].companyId)

      if (companySelected) {
        vm.user.companiesAccess[selectedCompanyIndex].profiles = companySelected.profiles
      }

      markDuplicateCompanies()
    }

    function markDuplicateCompanies() {
      vm.user.companiesAccess.forEach((company_n1, index_n1, companies) => {
        let count = 1

        companies.forEach((company_n2, index_n2) => {
          if (company_n1.companyId && company_n2.companyId && index_n1 != index_n2 && company_n1.companyId == company_n2.companyId) {
            vm.user.companiesAccess[index_n1].disabledProfile = true
            vm.user.companiesAccess[index_n2].disabledProfile = true

            vm.user.companiesAccess[index_n1].selectedDuplicateCompanies = true
            vm.user.companiesAccess[index_n2].selectedDuplicateCompanies = true

            count++
          }
        })

        if (count === 1 && vm.user.companiesAccess[index_n1].companyId) {
          vm.user.companiesAccess[index_n1].disabledProfile = false
          vm.user.companiesAccess[index_n1].selectedDuplicateCompanies = false
        }

        if (count === 1 && !vm.user.companiesAccess[index_n1].companyId) {
          vm.user.companiesAccess[index_n1].disabledProfile = true
          vm.user.companiesAccess[index_n1].selectedDuplicateCompanies = false
        }
      })
    }

    vm.addUser = () => {
      vm.modalUserError = false
      vm.user = {}
      vm.user.companies = []
      vm.user.companiesAccess = []
      vm.disableSelectPartnerCompany = false

      if ($rootScope.user_data.partner_companies.length == 1) {
        vm.disableSelectPartnerCompany = true
        vm.user.partner_companies = $rootScope.user_data.partner_companies
      }

      getCompaniesWithProfiles().then((companiesWithProfiles) => {
        vm.companiesWithProfiles = companiesWithProfiles

        vm.user.companiesAccess.push({
          companyId: $rootScope.user_data.company_id,
          profileId: '',
          profiles: vm.companiesWithProfiles.find(companyWithProfiles => companyWithProfiles.id == $rootScope.user_data.company_id).profiles
        })

        FoundationApi.publish('userModal', 'open')
      })
    }

    vm.changeTagsPartnerCompany = (action) => {
      if (vm.isLord || action === 'removed') {
        vm.disableInputPartnerCompany = false
        return
      }

      vm.disableInputPartnerCompany = true
    }

    vm.addExternalUser = function () {
      vm.user = {};
      vm.modalUserError = false;
      SesameAuthService
        .getSesameLinks()
        .$promise
        .then(function (data) {
          vm.sesameLinks = data;
        })
        .catch(function (data) {
          NotificationService.errorHandler(data, '');
        });
      FoundationApi.publish('externalUserModal', 'open');
    };
    vm.sesameFirstAccessLink = function () {
      SesameAuthService.generateSesameFirstAccessLink(null, vm.user)
        .$promise
        .then(function (data) {
          vm.sesameLink = data.link;
          vm.sesameLinks.unshift(data.sesameAccess);
          if (vm.sesameLinks.length > 10) {
            vm.sesameLinks.pop();
          }
        })
        .catch(function (error) {
          if (error.data && error.data.message) {
            errorHandler(error, error.data.message);
          } else {
            errorHandler(error, $rootScope.labels.errorProcRequi);
          }
        });
    };

    vm.btnAddCompanyAccess = () => {
      vm.user.companiesAccess.push({
        companyId: '',
        profileId: '',
        disabledProfile: true,
        profiles: {}
      })
    }

    vm.btnRemoveCompanyAccess = (index) => {
      vm.user.companiesAccess.splice(index, 1)

      markDuplicateCompanies()
    }

    // editar usuários
    vm.editUser = (userSelected) => {
      vm.user = angular.copy(userSelected)
      vm.user.companiesAccess = []

      if (vm.isLord) {
        vm.disableSelectPartnerCompany = false
      } else {
        vm.disableSelectPartnerCompany = $rootScope.checkMenuAccess('settings.myCompany.seeOnlyPartnerCompany')
      }

      getCompaniesWithProfiles().then((companiesWithProfiles) => {
        vm.companiesWithProfiles = companiesWithProfiles

        vm.user.companies.map((company, index) => {
          vm.user.companiesAccess.push({
            companyId: company.id,
            profileId: company.pivot.profile_id,
            profiles: vm.companiesWithProfiles.find(companyWithProfiles => companyWithProfiles.id == company.id).profiles
          })
        })

        vm.oldUserRole = vm.user.role;
        vm.modalUserError = false
        vm.user.inactive_since = moment(vm.user.inactive_since).format('DD/MM/YYYY')
        FoundationApi.publish('userModal', 'open')
      })
    }

    function getCompaniesWithProfiles(userId = null) {
      return new Promise((resolve) => {
        CompanyService.getCompaniesWithProfiles({id: userId})
        .$promise
        .then(function (data) {
          resolve(data)
        })
        .catch(function (error) {
          NotificationService.errorHandler(error, '');
        })
      })
    }

    vm.saveUser = function (formValid) {
      if (!canAlterUserRole(vm.user, vm.oldUserRole)) {
        NotificationService.warningHandler(null, $rootScope.labels.userOffToAlterRole);
        return false;
      }

      vm.user.operator_status = 0

      delete vm.user.password_error
      if (vm.user.id == undefined && !vm.user.password) {
        vm.modalUserError = true
        vm.user.password_error = true
        return false
      }

      if (formValid.$invalid) {
        vm.modalUserError = true
        return false
      }

      if (!vm.user.display_name) {
        vm.user.display_name = vm.user.name
      }

      if (vm.user.id == undefined) {
        UserService.create(null, vm.user)
          .$promise
          .then(function (data) {
            vm.company.users.push(data.user)
            successHandler(data, $rootScope.labels.sucCreateDatas)
            FoundationApi.publish('userModal', 'close')
          })
          .catch(function (error) {
            if (error.data && error.data.message) {
              errorHandler(error, error.data.message)
            } else {
              errorHandler(error, $rootScope.labels.errorProcRequi)
            }
          })
      } else {
        UserService.update(
          {id: vm.user.id},
          vm.user
        )
        .$promise
        .then(function (data) {
          vm.company.users.forEach((value, key) => {
            if (value.id == data.id) {
              vm.company.users[key] = data
            }
          })
          successHandler(null, $rootScope.labels.sucUpdDatas)
          FoundationApi.publish('userModal', 'close')
        })
        .catch(function (error) {
          if (error.data && error.data.message) {
            errorHandler(error, error.data.message)
          } else {
            errorHandler(error, $rootScope.labels.errorProcRequi)
          }
        })
      }
    }

    vm.btnCancelUser = () => {
      vm.user = {}
    }

    function canAlterUserRole (user, oldUserRole) {
      if (user && user.id !== undefined && user.operator_status == 1) {
        return user.role === oldUserRole;
      }
      return true;
    }

    vm.updateUserStatus = function (user, status) {
      UserService.setStatus({}, { user_id: user.id, status: status }, function (data) {
        successHandler(data, $rootScope.labels.sucAlterStatus)
      }, function (error) {
        errorHandler(error, $rootScope.labels.errorProcRequi)
      })
    }
    // controla setores dos usuários
    vm.manageSectors = function (user) {
      vm.editting_user = user

      for (var i = 0; i < vm.company.sectors.length; i++) {
        vm.selectedSectors[vm.company.sectors[i].id] = vm.belongsToSector(vm.editting_user.sectors, vm.company.sectors[i].id)
        vm.selectedSectorsTransferUser[vm.company.sectors[i].id] = vm.belongsToSector(vm.editting_user.sectors_transfer_user, vm.company.sectors[i].id)
      }

      FoundationApi.publish('userSectorsModal', 'open')
    }
    vm.belongsToSector = function (userSectorArray, sectorId) {
      if (!userSectorArray) return false

      var belongs = false

      for (var i = userSectorArray.length - 1; i >= 0; i--) {
        if (userSectorArray[i].id == sectorId) {
          belongs = true
          break
        }
      }

      FoundationApi.publish('userEditModal', 'close')
      return belongs
    }
    vm.saveUserSectors = function () {
      UserService.saveUserSectors({ id: vm.editting_user.id }, {
        sectors: vm.selectedSectors,
        sectors_transfer_user: vm.selectedSectorsTransferUser
      }, function () {
        vm.editting_user.sectors = []
        vm.editting_user.sectors_transfer_user = []
        for (var i in vm.selectedSectors) {
          if (vm.selectedSectors[i]) {
            vm.editting_user.sectors.push({ id: i })
          }
        }
        for (var i in vm.selectedSectorsTransferUser) {
          if (vm.selectedSectorsTransferUser[i]) {
            vm.editting_user.sectors_transfer_user.push({ id: i })
          }
        }
        successHandler(null, $rootScope.labels.sucUpdDatas)
      }, function (error) {
        errorHandler(error, $rootScope.labels.errorProcRequi)
      })
    }

    // SETORES
    vm.addSector = () => {
      if (!vm.new_sector || !vm.new_sector.name) {
        showNotification('error', 'Nome é obrigatório.')
        return
      }

      SectorService
        .create({
          id: vm.company.id,
          name: vm.new_sector.name
        })
        .$promise
        .then(function (data) {
          showNotification(data.messageType, data.message)

          if (!data.success) {
            return
          }

          vm.new_sector = {}
          vm.company.sectors.push(data.sector)
        })
        .catch(function (data) {
          NotificationService.errorHandler(data, $rootScope.labels.errorProcRequi)
        })
    }

    function showNotification(type, message) {
      if (type == 'success') {
        NotificationService.successHandler('', message)
      }

      if (type == 'warning') {
        NotificationService.warningHandler('', message)
      }

      if (type == 'error') {
        NotificationService.errorHandler('', message || $rootScope.labels.errorProcRequi)
      }
    }

    vm.deleteSector = function (index, sector) {
      SectorService.remove({
        'company_id': vm.company.id,
        'id': sector.id,
        '_method': 'PATCH'
      }
      ).$promise.then(function (data) {
        if (typeof data.error !== 'undefined') {
          NotificationService.warningHandler({}, data.error);
        } else {
          // success handler
          NotificationService.successHandler(data, 'Setor removido com sucesso!');
          vm.company.sectors.splice(index, 1);
        }

        FoundationApi.publish('sectorConfirmDeleteModal', 'close');
      }, function (error) {
        // error handler
        NotificationService.errorHandler(error, 'Erro ao processar requisição, por favor tente novamente.');
      });
    };

    vm.saveSectors = function () {
      SectorService.update({
        'id': vm.company.id,
        '_method': 'PATCH'
      },
      {
        'sectors': vm.company.sectors
      }
      ).$promise.then(function (data) {
        let sectorNameValidation = false
        vm.company.sectors.forEach((sector) => {
          if (!sector.name) {
            errorHandler('', $rootScope.labels.errorProcRequi)
            sectorNameValidation = true
          }
        });
        if (sectorNameValidation) {
          return
        }
        vm.company.sectors = data
        successHandler(data, $rootScope.labels.sucUpdDatas)
      }, function (error) {
        errorHandler(error, error.message)
      })
    }

    vm.confirmDeleteSector = function (index, sector) {
      vm.deletingIndex = index;
      vm.deleting = sector;
      FoundationApi.publish('sectorConfirmDeleteModal', 'open');
    };

    vm.addAddress = function () {
      vm.company.addresses.push({
        tipo: '',
        logradouro: '',
        numero: '',
        bairro: '',
        cep: '',
        cidade: '',
        observacao: ''
      })
    }

    vm.removeAddress = function (index) {
      vm.company.addresses.splice(index, 1)
    }

    vm.addResponsiblePerson = function () {
      vm.company.responsibles.push({
        nome: '',
        email: '',
        celular: '',
        titulo: '',
        telefone: ''
      })
    }

    vm.removeResponsiblePerson = function (index) {
      vm.company.responsibles.splice(index, 1)
    }

    vm.saveMetadata = function (number) {
      CompanyService.saveMetadata({ id: $stateParams.id }, vm.metadata, function (data) {
        successHandler(data, $rootScope.labels.sucUpdMetadatas)
      }, function (error) {
        errorHandler(error, $rootScope.labels.errorSaveMetadatas)
      })
    }

    vm.saveClassificationConfig = function (number) {
      if (!vm.metadata.hasOwnProperty('classification') ||
        !vm.metadata.classification.hasOwnProperty('paid_status') ||
        vm.metadata.classification.paid_status === 0) {
        return errorHandler(null, $rootScope.labels.requiredStatusPay)
      }
      CompanyService.saveClassificationConfig({ id: $stateParams.id }, vm.metadata, function (data) {
        successHandler(data, $rootScope.labels.configSaved)
      }, function (error) {
        errorHandler(error, $rootScope.labels.configError)
      })
    }

    vm.enableConfig = function (number) {
      CompanyService.saveClassificationConfig({ id: $stateParams.id }, vm.metadata, function (data) {
        CompanyService
          .allSectorsByKey({
            key: 'ai_classification'
          })
          .$promise
          .then(function (data) {
            vm.sectors = data
            successHandler(data, $rootScope.labels.configSaved)
          })
          .catch(function (data) {
            NotificationService.errorHandler(data, $rootScope.labels.errorProcRequi)
          })
      }, function (error) {
        errorHandler(error, $rootScope.labels.configError)
      })
    }

    vm.saveDashboard = function (number) {
      if (!vm.metadata.dashboard_days) {
        errorHandler(null, $rootScope.labels.daysInterval)
      } else if (!vm.metadata.dashboard_interval) {
        errorHandler(null, $rootScope.labels.minutesInterval)
      } else {
        CompanyService.saveMetadata({ id: $stateParams.id }, vm.metadata,
          function (data) {
            DashboardService.refresh({ id: $stateParams.id }
              , function (data) {
                successHandler(data, $rootScope.labels.paramsUpdated)
              }, function (error) {
                errorHandler(error)
              })
          }, function (error) {
            errorHandler(error, $rootScope.labels.errorUpdateParams)
          })
      }
    }

    vm.saveMailing = function () {
      if (typeof vm.metadata.mailingcampaigns !== 'undefined') {
        vm.metadata.mailingcampaigns.processed_file_name = 'campaign_%campaign_id%_filtered.txt'
      }

      if (vm.metadata.mailingcampaigns.hasOwnProperty('enabled') && !vm.metadata.mailingcampaigns.enabled) {
        vm.metadata.mailingcampaigns.enableWaent = false
      }

      if (vm.metadata.mailingcampaigns.hasOwnProperty('enableWaent') && !vm.metadata.mailingcampaigns.enableWaent) {
        vm.metadata.mailingcampaigns.enableSectors = false
        vm.metadata.mailingcampaigns.enableChatbot = false
      }

      CompanyService.saveMetadata({ id: $stateParams.id }, vm.metadata,
        function (data) {
          DashboardService.refresh({ id: $stateParams.id }
            , function (data) {
              successHandler(data, $rootScope.labels.paramsUpdated)
            }, function (error) {
              errorHandler(error, $rootScope.labels.errorUpdateParams)
            })
        },
        function (error) {
          errorHandler(error, $rootScope.labels.errorUpdateParams)
        })
    }

    FoundationApi.subscribe('userEmailSignature', function (event) {
      if (event == 'open') {
        vm.editing_signature = false
      }
      if (event == 'close') {
        vm.editing_signature = false
      }
    })

    vm.editAssinaturas = function (user) {
      vm.editting_user = user
      vm.userId = vm.editting_user.id
      FoundationApi.publish('userEmailSignature', 'open')
    }

    vm.editSignature = function (signature) {
      vm.selected_signature = signature
      vm.editing_signature = true
    }
    vm.newSignature = function () {
      vm.selected_signature = {}
      vm.selected_signature.user_id = vm.editting_user.id
      vm.editing_signature = true
    }
    vm.user_inactive_since_pikaday = {
      format: 'DD/MM/YYYY'
    }
    vm.dateSelected = function (date) {
      vm.user_inactive_since_pikaday.setDate(moment(date, 'DD/MM/YYYY'))
    }

    vm.getSignature = function (user_id) {
      UserSignatureService.select({ 'id': user_id })
      .$promise
        .then(function (data) {
          console.log(data.signature)
          vm.editting_user.signatures = data.signature
        })
        .catch(function (data) {
          NotificationService.errorHandler(data, '')
        })
    }

    vm.saveSignature = function (signature) {
      if (signature.id == undefined) {
        UserSignatureService.create({},
          signature,
          function (data) {
            vm.editing_signature = false
            successHandler(data, $rootScope.labels.sucSaveSign)

            if (data.success) {
              vm.getSignature(vm.userId)
            }
          },
          function (error) {
            errorHandler(error, $rootScope.labels.errorProcRequi)
          })
      } else {
        UserSignatureService.update({
          id: signature.id
        }, signature,
        function (data) {
          vm.editing_signature = false
          successHandler(data, $rootScope.labels.sucSaveSign)
        }, function (error) {
          errorHandler(error, $rootScope.labels.errorProcRequi)
        })
      }
    }

    vm.searchUserByEmailModal = function () {
      vm.foundUser = {}
      vm.searchUserEmail = ''
      FoundationApi.publish('userSearch', 'open')
    }

    vm.searchUserByEmail = function (searchUserEmail) {
      UserService
        .searchUserByEmail({ 'email': searchUserEmail })
        .$promise
        .then(function (data) {
          vm.foundUser = data
        })
        .catch(function (data) {
          NotificationService.errorHandler(data, '')
        })
    }

    function errorHandler (data, override_message) {
      var message = $rootScope.labels.errorTryAgain
      if (override_message) {
        message = override_message
      } else {
        if (data.data && data.data.message) {
          message = data.data.message
        }
      }
      notifSet.addNotification({ title: $rootScope.labels.error, content: message, autoclose: '3000', color: 'alert' })
    }

    function successHandler (data, override_message) {
      var message = $rootScope.labels.dataSaved
      if (override_message) {
        message = override_message
      } else {
        if (data && data.data && data.data.message) {
          message = data.data.message
        }
      }
      notifSet.addNotification({
        title: $rootScope.labels.success,
        content: message,
        autoclose: '3000',
        color: 'success'
      })
    }

    vm.filterUser = function () {
      // eslint-disable-next-line new-cap
      vm.userTable = new ngTableParams({
        page: 1,
        count: 25
      }, {
        getData: function ($defer, params) {
          if (!vm.content) {
            vm.content = {};
          }
          vm.content.page = params.page();

          UserService
            .filterUser(vm.content)
            .$promise
            .then(function (data) {
              if (data) {
                $defer.resolve(data.data)
                params.total(data.total)
                vm.totalUsers = data.total
                vm.company.users = data.data
                vm.getProfiles();
              } else {
                vm.userTable = false
                NotificationService.warningHandler(data, $rootScope.labels.errorNoRegistredUsers)
              }
            })
            .catch(function (error) {
              errorHandler(error, $rootScope.labels.errorFilterUsers)
            })
        }
      })
    }

    vm.getProfiles = function () {

      ProfileService
        .getAllNotPaginated()
        .$promise
        .then(function (data) {
          if (data) {
            vm.company.profiles = data
          } else {
            vm.userTable = false
            NotificationService.warningHandler(data, $rootScope.labels.errorNoRegistredUsers)
          }
        })
        .catch(function (error) {
          console.log('Error: ' ,error);
          errorHandler(error, $rootScope.labels.errorFilterUsers)
        })
    }

    /////////////INICIO HIERARQUIA DE PERFIS

    vm.getProfilesHierarchy = function() {
      // eslint-disable-next-line new-cap
      vm.profilesHierarchyTable = new ngTableParams({
        page: 1,
        count: 30
      }, {
        getData: function ($defer, params) {
          vm.content = {
            page: params.url().page,
            name: vm.profileFilter.name,
            status: vm.profileFilter.status
          }
          ProfileService
            .getProfilesHierarchy(vm.content)
            .$promise
            .then(function (data) {
              if(data){
                $defer.resolve(data.data)
                params.total(data.total)
                vm.profilesHierarchy = data;
              }
            })
            .catch(function (error) {
              console.log('Error: ', error);
              errorHandler(error, $rootScope.labels.errorProfilesHierarchy);
            })
        }
      })
    }

    vm.editProfileHistory = function(profile) {
      vm.editProfileHierarchy = profile;

      ProfileService
        .getModalProfileHierarchy(profile)
        .$promise
        .then(function (data) {
          if (data) {
            if (!data.hasOwnProperty('profile-0')){
              errorHandler(data, $rootScope.labels.noneProfileHistory);
              return;
            }

            vm.editProfilesHierarchyList = data;

            vm.parentProfileId = null;

            vm.checkProfilesDisabled(0, false);

            FoundationApi.publish('editProfilesHierarchyListModal', 'open')
          }
        })
        .catch(function (error){
          console.log('Error: ', error);
          errorHandler(error, $rootScope.labels.errorProfilesHierarchy);
        })
    }

    vm.checkProfilesDisabled = function(profileId, disabled) {
      vm.editProfilesHierarchyList['profile-' + profileId].forEach((value, index) => {
        value.disabled = disabled || value.id == vm.editProfileHierarchy.id;

        if (value.id == vm.editProfileHierarchy.id && value.parent_profile_id) {
          vm.parentProfileId = {};
          vm.parentProfileId[value.parent_profile_id] = true;
        }

        if (vm.editProfilesHierarchyList.hasOwnProperty('profile-' + value.id)) {
          vm.checkProfilesDisabled(value.id, value.disabled);
        }

        vm.editProfilesHierarchyList['profile-' + profileId][index] = value;
      });
    }

    vm.btnConfirmEditProfilesHierarchy = function() {
      vm.params = {
        editProfileHierarchy: vm.editProfileHierarchy,
        parentProfileId: vm.parentProfileId == null ? null : Object.keys(vm.parentProfileId)[0],
      }

      ProfileService
        .editProfilesHierarchy(vm.params)
        .$promise
        .then(function (data) {
          vm.getProfilesHierarchy();
          FoundationApi.publish('editProfilesHierarchyListModal', 'close');
          successHandler(data, $rootScope.labels.editProfilesHierarchySuccess);
        })
        .catch(function (error) {
          console.log('Error: ', error);
          errorHandler(error, $rootScope.labels.errorProfilesHierarchy);
        })
    }

    //////////////// FIM HIERARQUIA DE PERFIS


    // PERFIS
    vm.isChangeAllSubModules = []
    vm.isChangeAllActions = []

    // <<<<<<<<<< CADASTRAR PERFIL
    vm.btnCreateProfile = () => {
      vm.createProfile = {}
      vm.createProfile.error = {}
      vm.createProfile.fromExisting = false
      FoundationApi.publish('profileCreateModal', 'open')
    }

    vm.btnSaveCreateProfile = (form) => {
      if (form.name.$invalid) {
        vm.createProfile.error.name = true
      }

      if (form.fromProfileId.$invalid) {
        vm.createProfile.error.fromProfileId = true
      }

      if (form.$invalid) {
        return false
      }

      ProfileService
        .insert({
          from_existing: vm.createProfile.fromExisting,
          profile_id: vm.createProfile.fromProfileId,
          name: vm.createProfile.name
        })
        .$promise
        .then(function (data) {
          if (data.success === false) {
            NotificationService.warningHandler(null, data.message)
            return
          }

          if (vm.profileSearchForm.name) {
            vm.profileSearchForm.name = ''
          }

          vm.profileGetAll()

          NotificationService.successHandler(null, data.message)
          FoundationApi.publish('profileCreateModal', 'close')
        })
        .catch(function (data) {
          if (data.message) {
            NotificationService.errorHandler(data, data.message)
            return
          }

          NotificationService.errorHandler(data, $rootScope.labels.errorProcRequi)
        })
    }

    vm.btnCancelSaveCreateProfile = () => {
      delete vm.createProfile
    }
    // CADASTRAR PERFIL >>>>>>>>>>

    // <<<<<<<<<< EDITAR PERFIL
    vm.btnEditProfile = (profile) => {
      vm.editProfile = {}
      vm.editProfile.error = {}
      vm.profileSelected = profile
      FoundationApi.publish('profileEditModal', 'open')
    }

    vm.btnSaveEditProfile = (form) => {
      if (form.name.$invalid) {
        vm.editProfile.error.name = true
      }

      if (form.$invalid) {
        return false
      }

      ProfileService
        .update({
          _method: 'PUT',
          id: vm.profileSelected.id,
          name: vm.editProfile.name
        })
        .$promise
        .then(function (data) {
          if (data.success === false) {
            NotificationService.warningHandler(null, data.message)
            return
          }

          if (vm.profileSearchForm.name) {
            vm.profileSearch()
          } else {
            vm.profileGetAll()
          }

          NotificationService.successHandler(null, data.message)
          FoundationApi.publish('profileEditModal', 'close')
        })
        .catch(function (error) {
          if (error.data && error.data.message) {
            NotificationService.errorHandler(error, error.data.message)
            return
          }

          NotificationService.errorHandler(error, $rootScope.labels.errorProcRequi)
        })
    }

    vm.btnCancelSaveEditProfile = () => {
      delete vm.editProfile
      delete vm.profileSelected
    }
    // EDITAR PERFIL >>>>>>>>>>

    // <<<<<<<<<< DELETAR PERFIL
    vm.btnDeleteProfile = function (profile) {
      vm.profileSelected = profile
      FoundationApi.publish('deleteProfileModal', 'open')
    }

    vm.btnConfirmDeleteProfile = (profile) => {
      ProfileService
        .delete({
          _method: 'DELETE',
          id: profile.id
        })
        .$promise
        .then(function (data) {
          if (data.success === false) {
            NotificationService.warningHandler(null, vm.labelsProfile.warningDeletePerfil)
            return
          }

          if (vm.profileSearchForm.name) {
            vm.profileSearch()
          } else {
            vm.profileGetAll()
          }

          NotificationService.successHandler(null, data.message)
          FoundationApi.publish('deleteProfileModal', 'close')
        })
        .catch(function (error) {
          if (error.data && error.data.message) {
            NotificationService.errorHandler(error, error.data.message)
            return
          }

          NotificationService.errorHandler(error, $rootScope.labels.errorProcRequi)
        })
    }

    vm.btnCancelDeleteProfile = () => {
      delete vm.profileSelected
    }
    // DELETAR PERFIL >>>>>>>>>>

    // <<<<<<<<<< BUSCAR PERFIL
    vm.profileSearch = () => {
      if (vm.profileSearchForm.name === undefined || vm.profileSearchForm.name === '') {
        vm.profileGetAll()
        return
      }

      vm.profilesTable = new ngTableParams({
        page: 1,
        count: 30
      }, {
        getData: function ($defer, params) {
          ProfileService
            .search({name: vm.profileSearchForm.name})
            .$promise
            .then(function (data) {
              if (!data) {
                vm.profileTable = false
                NotificationService.warningHandler(data, $rootScope.labels.errorNoRegistredProfiles)
              }

              $defer.resolve(data.data)
              params.total(data.total)
              vm.totalProfiles = data.total
              vm.company.profiles = data.data
            })
            .catch(function (error) {
              if (error.data && error.data.message) {
                NotificationService.errorHandler(error, error.data.message)
                return
              }

              NotificationService.errorHandler(error, $rootScope.labels.errorProcRequi)
            })
        }
      })
    }
    // BUSCAR PERFIL >>>>>>>>>>

    // <<<<<<<<<< BOTÃO PERMISSÕES DO PERFIL
    vm.btnProfilePermissions = function (profile) {
      vm.profileSelected = profile
      vm.profile.checkSaveDefaultPermissions = false
      vm.disableButtonResetPermissions = true

      if (vm.profileSelected.default_permissions) {
        vm.disableButtonResetPermissions = false
      }

      PermissionControlRoutes
        .getAll()
        .$promise
        .then(data => {
          vm.permissionControl.all = data.modules
          getProfilePermissions(profile)
        }).catch(data => {
          NotificationService.errorHandler(data, vm.labelsProfile.errorConnectPermissions)
        })

      StatusService
        .allForProfileConfig()
        .$promise
        .then(data => {
          vm.statusAttendance = data
          getProfileStatus(profile)
        })
        .catch(error => {
          NotificationService.errorHandler(error, error)
        })

      SectorService
        .loadSectorsByCompany()
        .$promise
        .then(data => {
          vm.permissionsAllSectors = data.sectors
          vm.permissionsAllTransferSectors = angular.copy(data.sectors)

          permissionsAllTransferSectors().then(() => {
            getProfileTransferSectors(profile)
          })

          getProfileSectors(profile)
        })
        .catch(error => {
          NotificationService.errorHandler(error, error)
        })

      FoundationApi.publish('profilePermissionsModal', 'open')
    }

    function getProfilePermissions(profile) {
      PermissionControlRoutes
        .getByProfile({ profile_id: profile.id })
        .$promise
        .then(data => {
          comparePermissions(data.modules)
        }).catch(data => {
          NotificationService.errorHandler(data, data.message)
        })
    }

    function getProfileStatus(profile) {
      ProfileService
        .getStatus({profile_id: profile.id})
        .$promise
        .then(data => {
          if (data.length === 0) {
            vm.permissionsEnableStatusAttendance = false
            return
          }

          vm.permissionsEnableStatusAttendance = true
          compareStatus(data)
        })
        .catch(error => {
          NotificationService.errorHandler(error, error.message)
        })
    }

    function getProfileSectors(profile) {
      ProfileService
        .getSectors({profile_id: profile.id})
        .$promise
        .then(data => {
          if (data.length === 0) {
            vm.permissionsEnableSetors = false
            return
          }

          vm.permissionsEnableSetors = true
          compareSectors(data)
        })
        .catch(error => {
          NotificationService.errorHandler(error, error.message)
        })
    }

    function permissionsAllTransferSectors() {
      return new Promise((resolve) => {
        vm.permissionsAllTransferSectors.forEach((sector, sectorIndex) => {
          vm.permissionsAllTransferSectors[sectorIndex].checked = false
        })
        resolve('success')
      })
    }

    function getProfileTransferSectors(profile) {
      ProfileService.getTransferSectors({profile_id: profile.id})
      .$promise
      .then(data => {
        compareTransferSectors(data)
      })
      .catch(error => {
        NotificationService.errorHandler(error, error.message)
      })
    }
    // BOTÃO PERMISSÕES DO PERFIL >>>>>>>>>>

    function comparePermissions(profilePermissions) {
      vm.permissionControl.all.forEach((modulePermission, modulePermissionIndex) => {
        let moduleProfile = profilePermissions.find(moduleProfile => moduleProfile.id == modulePermission.id)

        if (moduleProfile === undefined || modulePermission.id !== moduleProfile.id) {
          return
        }

        modulePermission.sub_modules.forEach((subModulePermission, subModulePermissionIndex) => {
          let subModuleProfile = moduleProfile.sub_modules.find(subModuleProfile => subModuleProfile.id == subModulePermission.id)

          if (subModuleProfile === undefined || subModulePermission.id !== subModuleProfile.id) {
            vm.permissionControl.all[modulePermissionIndex].sub_modules[subModulePermissionIndex].checked = false
            return
          }

          vm.permissionControl.all[modulePermissionIndex].sub_modules[subModulePermissionIndex].checked = true

          subModulePermission.actions.forEach((actionPermission, actionPermissionIndex) => {
            let actionProfile = subModuleProfile.actions.find(actionProfile => actionProfile.id == actionPermission.id)

            if (actionProfile === undefined || actionPermission.id !== actionProfile.id) {
              vm.permissionControl.all[modulePermissionIndex].sub_modules[subModulePermissionIndex].actions[actionPermissionIndex].checked = false
              return
            }

            vm.permissionControl.all[modulePermissionIndex].sub_modules[subModulePermissionIndex].actions[actionPermissionIndex].checked = true
          })
        })

        vm.verifyIfAllSubModulesIsChecked(modulePermissionIndex)
      })
    }

    function compareStatus(profileStatuses) {
      vm.statusAttendance.forEach((status, statusIndex) => {
        let statusProfile = profileStatuses.find(statusProfile => statusProfile.id === status.id)

        if (statusProfile === undefined) {
          vm.statusAttendance[statusIndex].checked = false
          return
        }

        vm.statusAttendance[statusIndex].checked = true
      })

      vm.verifyIfAllStatusAttendanceIsChecked()
    }

    function compareSectors(sectorsInProfile) {
      vm.permissionsAllSectors.forEach((sector, sectorIndex) => {
        let sectorInProfile = sectorsInProfile.find(sectorInProfile => sectorInProfile.id === sector.id)

        if (sectorInProfile === undefined) {
          vm.permissionsAllSectors[sectorIndex].checked = false
          return
        }

        vm.permissionsAllSectors[sectorIndex].checked = true
      })
    }

    function compareTransferSectors(transferSectors) {
      vm.permissionsAllTransferSectors.forEach((sector, sectorIndex) => {
        let transferSector = transferSectors.find(transferSector => transferSector.id === sector.id)

        if (transferSector === undefined) {
          vm.permissionsAllTransferSectors[sectorIndex].checked = false
          return
        }

        vm.permissionsAllTransferSectors[sectorIndex].checked = true
      })
    }

    vm.profileChangeAllSubModules = (moduleId) => {
      if (vm.notChangeAllSubModules) {
        return
      }

      vm.permissionControl.all.forEach((modulePermission, modulePermissionIndex) => {
        modulePermission.sub_modules.forEach((subModulePermission, subModulePermissionIndex) => {
          if (modulePermission.all_sub_modules_checked == true && modulePermission.id == moduleId) {
            vm.permissionControl.all[modulePermissionIndex].sub_modules[subModulePermissionIndex].checked = true
          }
          if (modulePermission.all_sub_modules_checked == false && modulePermission.id == moduleId) {
            vm.permissionControl.all[modulePermissionIndex].sub_modules[subModulePermissionIndex].checked = false
          }
        })
      })
    }

    vm.profileChangeAllActions = (moduleId, subModuleId) => {
      vm.permissionControl.all.forEach((modulePermission, modulePermissionIndex) => {
        modulePermission.sub_modules.forEach((subModulePermission, subModulePermissionIndex) => {
          subModulePermission.actions.forEach((actionPermission, actionPermissionIndex) => {
            if (vm.isChangeAllActions[subModuleId] === true && subModulePermission.id == subModuleId) {
              vm.permissionControl.all[modulePermissionIndex].sub_modules[subModulePermissionIndex].actions[actionPermissionIndex].checked = true
            }
            if (vm.isChangeAllActions[subModuleId] === false && subModulePermission.id == subModuleId) {
              vm.permissionControl.all[modulePermissionIndex].sub_modules[subModulePermissionIndex].actions[actionPermissionIndex].checked = false
            }
          })
        })
      })
    }

    vm.profileChangeAllStatusAttendance = () => {
      if (vm.notChangeAllStatusAttendance) {
        return
      }

      vm.statusAttendance.forEach(status => {
        status.checked = vm.allStatusAttendanceChecked
      })
    }

    vm.verifyIfAllStatusAttendanceIsChecked = () => {
      verifyIfAllCheckboxIsChecked(vm.statusAttendance).then((result) => {
        if (result && !vm.allStatusAttendanceChecked) {
          document.getElementById('change_all_status_attendance').click()
        }

        if (!result && vm.allStatusAttendanceChecked) {
          vm.notChangeAllStatusAttendance = true
          document.getElementById('change_all_status_attendance').click()
        }

        vm.notChangeAllStatusAttendance = false
      })
    }

    vm.checkParentStatus = (status) => {
      if (status.checked) {
        let parentId = status.parent_menu_id;
        let parentIndex = vm.statusAttendance.findIndex(status => status.id == parentId);

        if (parentIndex != -1) {
          vm.statusAttendance[parentIndex].checked = true;
        }
      }
    }

    vm.profile.restoreDefaultPermissions = () => {
      restoreDefaultModules().then(() => {
        restoreDefaultStatus().then(() => {
          restoreDefaultSectors().then(() => {
            NotificationService.successHandler(null, 'Permissões restauradas')
          })
        })
      })
    }

    function restoreDefaultModules() {
      return new Promise((resolve) => {
        vm.permissionControl.all.forEach((module, moduleIndex) => {
          vm.isChangeAllSubModules[module.id] = false

          module.sub_modules.forEach((subModule, subModuleIndex) => {
            vm.isChangeAllActions[subModule.id] = false
            vm.permissionControl.all[moduleIndex].sub_modules[subModuleIndex].checked = false

            const permissionDefault = vm.profileSelected.default_permissions.permissions.find(permissionsDefault => permissionsDefault.sub_module === subModule.id)

            if (permissionDefault !== undefined) {
              vm.permissionControl.all[moduleIndex].sub_modules[subModuleIndex].checked = true
            }

            subModule.actions.forEach((action, actionIndex) => {
              vm.permissionControl.all[moduleIndex].sub_modules[subModuleIndex].actions[actionIndex].checked = false

              if (permissionDefault === undefined) {
                return
              }

              const actionDefault = permissionDefault.actions.includes(action.id)

              if (actionDefault) {
                vm.permissionControl.all[moduleIndex].sub_modules[subModuleIndex].actions[actionIndex].checked = true
              }
            })
          })
        })
        resolve('success')
      })
    }

    function restoreDefaultStatus() {
      return new Promise((resolve) => {
        vm.statusAttendance.forEach((status) => {
          status.checked = false

          const statusDefault = vm.profileSelected.default_permissions.status.includes(status.id)

          if (statusDefault) {
            status.checked = true
          }
        })
        resolve('success')
      })
    }

    function restoreDefaultSectors() {
      return new Promise((resolve) => {
        vm.permissionsAllSectors.forEach((sectors) => {
          sectors.checked = false

          const sectorsDefault = vm.profileSelected.default_permissions.sectors.includes(sectors.id)

          if (sectorsDefault) {
            sectors.checked = true
          }
        })
        resolve('success')
      })
    }

    vm.btnProfilePermissionsSave = () => {
      if (vm.validateSubmoduleWithoutAction()) {
        NotificationService.warningHandler(null, $rootScope.labels.errorSubmoduleWithoutAction);
        return;
      }

      let selectedPermissions = []
      vm.permissionControl.all.forEach((modulePermission) => {
        modulePermission.sub_modules.forEach((subModulePermission) => {
          if (!subModulePermission.checked) {
            return
          }

          let selected = {
            type: 'write',
            module: modulePermission.id,
            sub_module: subModulePermission.id,
            actions: []
          }

          subModulePermission.actions.forEach((actionPermission) => {
            if (!actionPermission.checked) {
              return
            }
            selected['actions'].push(actionPermission.id)
          })

          selectedPermissions.push(selected)
        })
      })

      let selectedStatus = []
      if (vm.permissionsEnableStatusAttendance) {
        vm.statusAttendance.forEach((status) => {
          if (!status.checked) {
            return
          }

          selectedStatus.push(status.id)
        })
      }

      let selectedSectors = []
      if (vm.permissionsEnableSetors) {
        vm.permissionsAllSectors.forEach(sector => {
          if (!sector.checked) {
            return
          }

          selectedSectors.push(sector.id)
        })
      }

      let permissionsSelectedTransferSectors = []
      vm.permissionsAllTransferSectors.forEach(sector => {
        if (!sector.checked) {
          return
        }

        permissionsSelectedTransferSectors.push(sector.id)
      })

      ProfileService
        .syncPermissions({
          profile_id: vm.profileSelected.id,
          permissions: selectedPermissions,
          status: selectedStatus,
          sectors: selectedSectors,
          profile_transfer_sectors: permissionsSelectedTransferSectors,
          save_default: vm.profile.checkSaveDefaultPermissions
        })
        .$promise
        .then((data) => {
          if (!data.success) {
            NotificationService.warningHandler(data, $rootScope.labels.ErrorSavingPermissions);
            return;
          }

          NotificationService.successHandler(data, $rootScope.labels.SuccessfullySavedPermissions)
          FoundationApi.publish('profilePermissionsModal', 'close')
          vm.permissionsReset()
        })
        .catch((error) => {
          if (error.data && error.data.message) {
            NotificationService.errorHandler(error, error.data.message)
            return
          }

          NotificationService.errorHandler(error, $rootScope.labels.errorProcRequi)
        })
    }

    vm.permissionsReset = () => {
      vm.isChangeAllSubModules = []
      vm.isChangeAllActions = []
      vm.permissionsEnableStatusAttendance = false
      vm.permissionsEnableSetors = false
      vm.disableButtonResetPermissions = true
      delete vm.profileSelected
      delete vm.permissionControl.all
      delete vm.statusAttendance
      delete vm.permissionsAllSectors
      delete vm.permissionsAllTransferSectors

      let accordionStatus = document.querySelector('#accordion_items_status_attendance.accordion-item.is-active .accordion-title')
      if (accordionStatus) {
        accordionStatus.click()
      }

      let accordionSectors = document.querySelector('#accordion_items_sectors.accordion-item.is-active .accordion-title')
      if (accordionSectors) {
        accordionSectors.click()
      }

      let accordionTransferSectors = document.querySelector('#accordion_items_transfer_sectors.accordion-item.is-active .accordion-title')
      if (accordionTransferSectors) {
        accordionTransferSectors.click()
      }

      if (vm.profileSearchForm.name) {
        vm.profileSearch()
        return
      }

      vm.profileGetAll()
    }

    vm.showModalItemsStatusAttendance = function () {
      FoundationApi.publish('itemsStatusAttendanceModal', 'open')
    }

    vm.showModalItemsSectors = () => {
      FoundationApi.publish('itemsSectorsModal', 'open')
    }

    vm.profileGetAll = function () {
      if (vm.profileSearchForm.name) {
        vm.profileSearchForm.name = ''
      }

      vm.profilesTable = new ngTableParams({
        page: 1,
        count: 30
      }, {
        getData: function ($defer, params) {
          ProfileService.getAll({
              page: params.url().page
            })
            .$promise
            .then(function (data) {
              if (!data) {
                vm.profileTable = false
                NotificationService.warningHandler(data, $rootScope.labels.errorNoRegistredProfiles)
                return
              }

              $defer.resolve(data.data)
              params.total(data.total)
              vm.totalProfiles = data.total
              vm.company.profiles = data.data
            })
            .catch(function (error) {
              if (error.data && error.data.message) {
                NotificationService.errorHandler(error, error.data.message)
                return
              }

              NotificationService.errorHandler(error, $rootScope.labels.errorProcRequi)
            })
        }
      })
    }

    vm.changeAllTransferSector = () => {
      vm.permissionsAllTransferSectors.forEach((sector, sectorIndex) => {
        vm.permissionsAllTransferSectors[sectorIndex].checked = vm.checkChangeAllTransferSector
      })
    }

    vm.verifyIfAllSubModulesIsChecked = (moduleIndex) => {
      verifyIfAllCheckboxIsChecked(vm.permissionControl.all[moduleIndex].sub_modules).then((result) => {
        if (result && !vm.permissionControl.all[moduleIndex].all_sub_modules_checked) {
          document.getElementById('change_all_module_' + vm.permissionControl.all[moduleIndex].id).click()
        }

        if (!result && vm.permissionControl.all[moduleIndex].all_sub_modules_checked) {
          vm.notChangeAllSubModules = true
          document.getElementById('change_all_module_' + vm.permissionControl.all[moduleIndex].id).click()
        }

        vm.notChangeAllSubModules = false
      })
    }

    function verifyIfAllCheckboxIsChecked(items) {
      return new Promise((resolve) => {
        items.forEach(item => {
          if (!item.checked) {
            resolve(false)
          }
        })

        resolve(true)
      })
    }

    function getPartnerCompanies() {
      CompanyService
          .getAllPartnerCompanies()
          .$promise
          .then(function (data) {
              if (data.partnerCompanies) {
                  vm.partnerCompanies = data.partnerCompanies;
              } else {
                  NotificationService.errorHandler(data, $rootScope.labels.errorLoadingPartnerCompanies);
              }
          }).catch(function (data) {
              NotificationService.errorHandler(data, $rootScope.labels.errorDatabaseCommunication);
          });
    }

    vm.addPartnerCompanyModal = function () {
      vm.partnerCompany = {};
      FoundationApi.publish('registerPartnerCompanyModal', 'open');
    }

    vm.savePartnerCompany = function (data) {

      if (!vm.partnerCompany.name) {
          NotificationService.errorHandler(data, $rootScope.labels.fieldNameRequired);
          return;
      }

      CompanyService
          .store(vm.partnerCompany)
          .$promise
          .then(function (data) {
              vm.filterPartnerCompanies();
              getPartnerCompanies();
              vm.partnerCompany.name = '';
              NotificationService.successHandler(data, $rootScope.labels.registeredSuccess);
              FoundationApi.publish('registerPartnerCompanyModal', 'close');
          }).catch(function (data) {
              NotificationService.errorHandler(data, $rootScope.labels.errorDatabaseCommunicationRegister);
          });
    }

    vm.filterPartnerCompanies = function () {
       vm.partnerCompaniesTable = new ngTableParams({
          page: 1,
          count: 25
       },{
        getData: function ($defer, params) {
          vm.content.page = params.url().page;
          CompanyService
            .filter(vm.content)
            .$promise
            .then(function (data) {
              if (data) {
                $defer.resolve(data.data);
                params.total(data.total);
                vm.totalPartnerCompanies = data.total;
              } else {
                vm.partnerCompaniesTable = false;
                NotificationService.warningHandler(data, $rootScope.labels.errorNoRegistredPartnerCompanies);
              }
            })
            .catch(function (error) {
              errorHandler(error, $rootScope.labels.errorFilterPartnerCompanies);
            })
          }
       })
      }

    vm.filterUserAudits = function () {
      // eslint-disable-next-line new-cap
      vm.userAuditTable = new ngTableParams({
        page: 1,
        count: 25
      }, {
        getData: function ($defer, params) {
          vm.content.page = params.url().page
          UserAuditService
            .filterUserAudits(vm.content)
            .$promise
            .then(function (data) {
              if (data) {
                $defer.resolve(data.data)
                params.total(data.total)
                vm.totalUserAudits = data.total
                vm.company.userAudits = data.data
              } else {
                vm.userAuditTable = false
                NotificationService.warningHandler(data, $rootScope.labels.errorNoRegistredUsers)
              }
            })
            .catch(function (error) {
              errorHandler(error, $rootScope.labels.errorFilterUsers)
            })
        }
      })
    }

    vm.showModalSubModuleActions = function (moduleIndex, subModuleIndex) {
      vm.permissionControl.moduleIndex = moduleIndex
      vm.permissionControl.subModuleIndex = subModuleIndex

      vm.permissionControl.module = vm.permissionControl.all[moduleIndex]
      vm.permissionControl.subModule = vm.permissionControl.all[moduleIndex].sub_modules[subModuleIndex]
      FoundationApi.publish('subModuleActionsModal', 'open')
    }

    vm.editPartnerCompanyModal = function (partnerCompanyId) {
      vm.partnerCompanyEdit = {};
      CompanyService
          .getPartnerCompaniesById({id: partnerCompanyId})
          .$promise
          .then(function (data) {
              if (data.partnerCompanies) {
                  vm.partnerCompanyEdit.id = data.partnerCompanies.id;
                  vm.partnerCompanyEdit.name = data.partnerCompanies.name;
              } else {
                  NotificationService.errorHandler(data, $rootScope.labels.executionErrorEdit);
              }
          }).catch(function (data) {
              NotificationService.errorHandler(data, $rootScope.labels.errorDatabaseCommunicationEdit);
          });
    }

    vm.saveEditModal = function (data) {

      if (!vm.partnerCompanyEdit.name) {
        NotificationService.errorHandler(data, $rootScope.labels.fieldNameRequired);
        return;
      }

      CompanyService
          .updatePartnerCompany(vm.partnerCompanyEdit)
          .$promise
          .then(function (data) {
              vm.filterPartnerCompanies();
              vm.partnerCompanyEdit = {};
              NotificationService.successHandler(data, $rootScope.labels.editSuccess);
              FoundationApi.publish('editPartnerCompanyModal', 'close');
          }).catch(function (data) {
              NotificationService.errorHandler(data, $rootScope.labels.errorDatabaseCommunicationSaveEdit);
          });
    }

    vm.deleteConfirm = function (partnerCompanyId) {
      vm.partnerCompanyId = partnerCompanyId;
      FoundationApi.publish('partnerCompaniesConfirmDeleteModal', 'open');
    }

    vm.delete = function (partnerCompanyId) {
      CompanyService
          .delete(partnerCompanyId)
          .$promise
          .then(function (data) {
              vm.filterPartnerCompanies();
              if (data.success) {
                NotificationService.successHandler(data, $rootScope.labels.deleteSuccess);
                FoundationApi.publish('partnerCompaniesConfirmDeleteModal', 'close');
              }
          }).catch(function (data) {
              NotificationService.errorHandler(data, $rootScope.labels.errorDatabaseCommunicationDelete);
          });
    }

    vm.searchTimezones = function () {
      vm.timezones = undefined
      if (!vm.selected_country) {
        return false
      }
      CompanyService
        .loadTimezonesByCountry({ initials: vm.selected_country.initials })
        .$promise
        .then(function (data) {
          vm.timezones = data
        })
        .catch(function (error) {
          NotificationService.errorHandler(error, 'Erro ao carregar fuso horários.')
        })
    }

    vm.verifyCorrectFormatDate = function () {
      if (vm.first_date_field.value == vm.second_date_field.value) {
        vm.second_date_field = {}
      }
      if (vm.first_date_field.value == vm.third_date_field.value) {
        vm.third_date_field = {}
      }
      if (vm.second_date_field.value == vm.third_date_field.value) {
        vm.third_date_field = {}
      }
    }

    vm.saveLocalization = function () {
      let formatDate = vm.first_date_field.value + vm.dateSeparator + vm.second_date_field.value +
        vm.dateSeparator + vm.third_date_field.value
      if (!vm.first_date_field.value || !vm.second_date_field.value || !vm.third_date_field.value) {
        NotificationService.warningHandler(null, 'Formato da data incorreto.')
        return false
      }
      if (vm.selected_country == null) {
        NotificationService.warningHandler(null, 'Fuso horário não escolhido.')
        return false
      }
      if (vm.selected_locale == null) {
        NotificationService.warningHandler(null, 'Língua não escolhida.')
        return false
      }
      if (vm.selected_timezone == null) {
        NotificationService.warningHandler(null, 'Fuso horário não escolhido.')
        return false
      }
      CompanyService
        .saveLocalizationConfig({
          country: vm.selected_country,
          timezone: vm.selected_timezone,
          dateSeparator: vm.dateSeparator,
          formatDate: formatDate,
          currency: vm.selected_currency,
          locale: vm.selected_locale
        })
        .$promise
        .then(function (data) {
          NotificationService.successHandler(null, 'Dados gravados com sucesso!')
        })
        .catch(function (error) {
          NotificationService.errorHandler(error, 'Não foi possível concluir sua solicitação.')
        })
    }

    vm.showSectors = function () {
      FoundationApi.publish('sectorsModal', 'open')
    }

    vm.defineSectorsIA = function (key, label) {
      var sectors = document.getElementsByName('sectors')
      var sectorsArr = []

      for (var i = 0; i < sectors.length; i++) {
        var sector = { id: sectors[i].id, active: sectors[i].checked }
        sectorsArr.push(sector)
      }

      CompanyService
        .saveSectors({
          key: key,
          label: label,
          sectors: sectorsArr
        })
        .$promise
        .then(function (data) {
          NotificationService.successHandler(data, $rootScope.labels.paramsUpdated)
          FoundationApi.publish('sectorsModal', 'close')
        })
        .catch(function (data) {
          NotificationService.errorHandler(data, $rootScope.labels.errorUpdateParams)
        })
    }

    vm.setDefault = function (removeAt) {
      if (removeAt.toUpperCase() == 'LOGO') {
        if (vm.company.view_data.hasOwnProperty('logo') && vm.company.view_data.logo != null) {
          vm.company.view_data.logo = null
        }
      }
      if (removeAt.toUpperCase() == 'LOGO_LOGIN') {
        if (vm.company.view_data.hasOwnProperty('logo_login') && vm.company.view_data.logo_login != null) {
          vm.company.view_data.logo_login = null
        }
      }
    }

    vm.uploadPhoto = function (file, index, key) {
      if (file) {
        if (file.length) {
          // Pode ser que a coluna view_data tenha um [] ou {} como valor, este if
          // faz a tratativa disso para que as imagens selecionadas possam ser
          // salvas na base
          if (!vm.company.view_data || vm.company.view_data['title'] == undefined) {
            vm.company.view_data = {
              'title': vm.company.name,
              'logo': '',
              'logo_login': ''
            }
          }

          file.upload = Upload.upload({
            url: baseUrl + '/whitelabel-upload',
            fields: { key: key },
            file: file
          })

          file.upload.then(function (response) {
            $timeout(function () {
              vm.company.view_data[key] = response.data.url
            })
          }).catch(function (response) {
            if (response.status > 0) {
              console.log(response.status + ': ' + response.data);
            }
          });
        }
      }
    };

    vm.copy = function (url) {
      var textArea = document.createElement('textarea');
      textArea.value = url;
      document.body.appendChild(textArea);
      textArea.focus();
      textArea.select();

      document.execCommand('copy');

      document.body.removeChild(textArea);
    }

    vm.copyLink = function (link) {
      var url = mktzapUrl + '/sesame-mktzap/' + link;
      vm.copy(url)
    }

    vm.deleteSesameLinkConfirm = function (link) {
      vm.deletingSesameLink = link;
      FoundationApi.publish('deleteExternalUserModal', 'open');
    }

    vm.deleteSesameLink = function (id) {
      SesameAuthService
        .deleteSesameLink({ 'id': id })
        .$promise
        .then(function (data) {
          if (data.success) {
            SesameAuthService
              .getSesameLinks()
              .$promise
              .then(function (data) {
                vm.sesameLinks = data;
              })
              .catch(function (data) {
                NotificationService.errorHandler(data, '');
              });
          } else {
            NotificationService.errorHandler(data, '');
          }
          vm.deletingSesameLink = {};
          NotificationService.successHandler(data, '');
          FoundationApi.publish('deleteExternalUserModal', 'close');
        });
    }

    vm.confirmDeleteIp = function (ip) {
      vm.ip = ip
      FoundationApi.publish('ConfirmDeleteModal', 'open')
    }

    vm.deleteIp = function (ip) {
      var index = vm.company.data.ips.indexOf(ip)
      vm.company.data.ips.splice(index, 1)
      vm.saveListIp()
      FoundationApi.publish('ConfirmDeleteModal', 'close')
      vm.ip = []
    }

    vm.addIp = function (ip) {
      if (!vm.company.data.ips) {
        vm.company.data.ips = []
      }

      var code = ValidateService.validateIpWhitelist(vm.company.data.ips, ip)

      switch (code) {
        case ValidateService.IP_CODES.EMPTY_FIELD:
          NotificationService.warningHandler(null, $rootScope.labels.ipError)
          break
        case ValidateService.IP_CODES.INVALID_IP:
          NotificationService.warningHandler(null, $rootScope.labels.ipInvalidError)
          break
        case ValidateService.IP_CODES.ALREADY_EXISTS:
          NotificationService.warningHandler(null, $rootScope.labels.theIP + ip + $rootScope.labels.existIp)
          break
        case ValidateService.IP_CODES.REGISTER_SUCCESS:
          vm.company.data.ips.push(ip)
          vm.ip_add = []
          vm.saveListIp()
          break
      }
    }

    vm.saveListIp = function () {
      CompanyService
        .saveData(vm.company.data)
        .$promise
        .then(function (data) {
          NotificationService.successHandler(null, $rootScope.labels.sucSaveDat)
        })
        .catch(function (error) {
          NotificationService.errorHandler(error, $rootScope.labels.errorIp)
        })
    }

    vm.validateSubmoduleWithoutAction = function() {
      let hasSubModuleWithoutAction = false;

      vm.permissionControl.all.forEach((modulePermission) => {
        modulePermission.sub_modules.forEach((subModulePermission) => {
          if (!subModulePermission.checked) {
            return;
          }

          if (subModulePermission.actions.length) {
            let selectedActions = subModulePermission.actions.find(actionPermission => actionPermission.checked == true);
            if (!selectedActions) {
              hasSubModuleWithoutAction = true;
            }
          }
        });
      });

      if (hasSubModuleWithoutAction) {
        return true;
      }

      return false;
    }
  }
})();
